// extracted by mini-css-extract-plugin
module.exports = {"meals":"FUQS3jopI4UN2x-V-cTVBg==","meals-appear":"rkc4+-ZxQJAB2OVe4PUBUg==","MealIsLoading":"TcgrbQTlFx1Myc5Zd3xjTg==","MealsError":"ExOm01zCR8go2syGJ7s02w=="};